<!-- Modal LOGIN-->
<div class="modal fade contenedor-modal" id="modalLogin" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body p-0">
        <app-login-form [esModal]="true" (resultEvent)="onLogin($event)" (goRegister)="abrirModal(modalRegister)">
        </app-login-form>
      </div>
    </div>
  </div>
</div>

<!-- Modal REGISTRO-->
<div class="modal fade contenedor-modal" id="modalRegister" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body p-0">
        <app-register-form [esModal]="true" (resultEvent)="onRegister($event)" (goLogin)="abrirModal(modalLogin)">
        </app-register-form>
      </div>
    </div>
  </div>
</div>

<!-- MODAL TRAILER -->
<div class="modal fade contenedor-modal" id="modalTrailer" tabindex="-1" aria-hidden="true" *ngIf="movie?.trailerLink">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-body p-0" style="background-color: #060613">
        <iframe *ngIf="reproducirTrailer && tipoTrailer == 'youtube'" class="trailer"
          [src]="movie.trailerLinkIframe | safe" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>

        <div *ngIf="reproducirTrailer && tipoTrailer == 'vimeo'" style="padding: 56.25% 0 0 0; position: relative">
          <iframe [src]="movie.trailerLinkIframe | safe"
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%" frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
        </div>

        <div class="p-5 d-flex justify-content-center" *ngIf="!reproducirTrailer">
          <div class="spinner-border mt-2" style="width: 3rem; height: 3rem" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal TARJETAS-->
<div class="modal fade contenedor-modal" id="modalPayment" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="mostrarTarjetas">
      <div class="modal-body p-0">
        <app-payment-options [info]="infoCompra" [typeTransaction]="objetoPurchase.type"
          [objetoPurchase]="objetoPurchase" [ppv]="true"></app-payment-options>
      </div>
    </div>
  </div>
</div>

<!-- ----------------------------------------------------------------------------------------------------------------- -->

<div class="tela animate__animated " [ngClass]="{'active':fadeOut, 'animate__fadeIn':fadeOut}"></div>

<!-- FICHA PELICULA -->
<div class="row" *ngIf="movie">
  <div class="col-12 movieTemplate">

    <!-- <div class="label-movie bg-warning" *ngIf="esEstreno">ESTRENO</div>
    <div class="label-movie bg-danger text-white" *ngIf="esCinema">EN SALAS</div> -->

    <!-- PORTADA - FOTO - BOTONES -->
    <div class="portada">
      <div class="medias">

        <!-- Cocarda Free-->
        <div class="tarjeta__cocarda" *ngIf="isFree">
          <div class="tarjeta__cocarda-line">
            GRATIS
          </div>
        </div>
        <!-- Cocarda Estreno-->
        <div class="tarjeta__cocarda" *ngIf="esEstreno">
          <div class="tarjeta__cocarda-line line-estreno">
            ESTRENO
          </div>
        </div>
        <!-- Cocarda Sala-->
        <div class="tarjeta__cocarda" *ngIf="esCinema">
          <div class="tarjeta__cocarda-line line-salas">
            EN SALAS
          </div>
        </div>

        <!-- <div class="fade-principal"></div> -->
        <div class="fade-bajo"></div>

        <swiper [config]="mySwiper">
          <div class="swiper-slide" *ngFor="let picture of movie.picturesNoPoster">
            <img class="imagen" [src]="picture.pictureLinkFull" alt="" />
          </div>
        </swiper>
      </div>

      <div class="informacion">
        <div class="row">
          <div class="col-12 px-xl-5">
            <!-- INFORMACION BASICA  -->
            <div class="row">
              <div class="col-12 col-lg-7 basica">
                <div class="titulo">{{ movie.title }}</div>
                <div class="subtitulo">{{ movie.originalTitle }}</div>
                <div class="cast-genero">
                  <div>{{ movie.directorFullName }}</div>
                  <div class="ml-2 mr-2 pb-2">.</div>
                  <div>{{ movie.genre.name }}</div>
                </div>
              </div>
            </div>

            <!-- MAS INFORMACION -->
            <div class="row">
              <div class="col-12 col-lg-2">
                <div class="w-100 mas-informacion">
                  <div class="anio">{{ movie.releaseYear }}</div>
                  <div class="ml-2 mr-2 pb-2">.</div>

                  <div class="duracion">{{ movie.length }}min</div>
                  <div class="ml-2 mr-2 pb-2">.</div>

                  <div class="subtitulo">{{ movie.hasSubtitle ? 'Subtitulado' : '' }}</div>
                  <!-- Aun no tenemos este dato -->
                  <!-- <div class="clasificacion">12+</div> -->
                </div>
              </div>
            </div>

            <!-- Cartelito de score -->
            <!-- <div class="row">
              <div class="col-1 pt-3" *ngIf="movieScore > 0">

              </div>
            </div> -->

            <!-- SINOPSIS -->
            <div class="row d-none d-lg-flex">
              <div class="col-10 col-lg-10 mt-4 sinopsis">
                <p class="texto" [innerHtml]="movie.synopsis"></p>
              </div>
              <div class="col-2 col-lg-2 mt-4 colscores" *ngIf="movieScore > 0">
                <div class="pb-2 movieScore">
                  <a class=" ratingText" (click)="onOpenScores()">{{movieScore}}</a>
                  <div class="starsInScore">
                    <app-raiting [useAlternativeColor]="true" [score]="5"></app-raiting>
                  </div>
                </div>
              </div>
            </div>

            <!-- BOTONES -->
            <div class="row buttons-parent">
              <div class="col-12 col-md-6  mt-3 barra-baja">

                <!-- Ver ahora -->
                <button class="pink" type="button" (click)="watchMovie()" [disabled]="!ipValid"
                  [ngClass]="{'op-06': !ipValid}" *ngIf="movie?.movieLink && tccLinkExists">

                  <svg width=" 1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-play m-0" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                      d="M10.804 8L5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
                  </svg>

                  <span>VER AHORA</span>
                </button>

                <!-- Ver trailer -->
                <button class="silver" type="button" (click)="watchTrailer()" *ngIf="movie?.trailerLink">
                  <svg width="1.3em" height="1.3em" viewBox="0 0 16 16" class="bi bi-tv" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                      d="M2.5 13.5A.5.5 0 0 1 3 13h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zM13.991 3H2c-.325 0-.502.078-.602.145a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3zM14 2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h12c2 0 2-2 2-2V4c0-2-2-2-2-2z" />
                  </svg>
                  <span class="d-inline ml-3">TRAILER</span>
                </button>

              </div>

              <!-- TABS BUTTONS -->
              <div class="col-12 col-md-6 col-lg-5 col-xl-4 mt-4 p-0 tabsButtons">
                <div class="row">
                  <!-- info -->
                  <div class="col-4 px-0 tabButtonContainer">
                    <a class="tabButton" *ngIf="tabSelected != 1" (click)="clickedInfo()">Información</a>
                    <a class="tabButtonUnderline" *ngIf="tabSelected == 1">
                      <u class="underlinePart">
                        Información
                      </u>
                    </a>
                  </div>
                  <!-- comments -->
                  <div class="col-4 px-0 tabButtonContainer">
                    <a class="tabButton" *ngIf="tabSelected != 2" (click)="clickedComments()">Comentarios</a>
                    <a class="tabButtonUnderline" *ngIf="tabSelected == 2">
                      <u class="underlinePart">
                        Comentarios
                      </u>
                    </a>
                  </div>
                  <!-- frames -->
                  <div class="col-4 px-0 tabButtonContainer">
                    <a class="tabButton" *ngIf="tabSelected != 3" (click)="clickedFrames()">Fotogramas</a>
                    <a class="tabButtonUnderline" *ngIf="tabSelected == 3">
                      <u class="underlinePart">
                        Fotogramas
                      </u>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- MENSAJES -->
            <div class="row" *ngIf="!ipValid">
              <div class="col-12 col-md-7 mt-1 barra-baja mb-2">

                <span class="text-white fs-5">
                  <i class="bi bi-dash-circle-dotted"></i>
                  Restringido para esta región.
                </span>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- PANELES BAJOS -->
    <div class="paneles">
      <div class="row">
        <div class="col-12 px-xl-5">
          <!-- TAB DE INFO ACA -->
          <div class="row" *ngIf="tabSelected == 1">
            <!-- PANELES IZQUIERDA -->
            <div class="col-12 col-xl-8">
              <!-- SINOPSIS -->
              <div class="card text-white mb-4">
                <div class="card-body">
                  <div class="titulo">Sinopsis</div>
                  <p class="texto" [innerHtml]="san.bypassSecurityTrustHtml(movie.description)"></p>
                </div>
              </div>

              <!-- CATEGORIAS -->
              <div class="card text-white mb-4" *ngIf="movie.categories.length > 0">
                <div class="card-body">
                  <div class="titulo">Categorías</div>

                  <div class="categorias">
                    <!-- <a href="/tag-search/{{tag_type.categorias}}/{{categoria.id}}?label={{categoria.name}}" -->
                    <a [href]="'/tag-search/' + tag_type.categorias + '/' + categoria.id + '?label=' + categoria.name"
                      class="badge badge-pill badge-dark mr-3 mb-3" *ngFor="let categoria of movie.categories">{{
                      categoria.name }}</a>
                  </div>
                </div>
              </div>

              <!-- TEMAS -->
              <div class="card text-white mb-4" *ngIf="movie.topics.length > 0">
                <div class="card-body">
                  <div class="titulo">Temas</div>

                  <div class="temas">
                    <a [href]="'/tag-search/' + tag_type.tema + '/' + topico.id + '?label=' + topico.name"
                      class="badge badge-pill badge-dark mr-3 mb-3" *ngFor="let topico of movie.topics">{{
                      topico.name
                      }}</a>
                  </div>
                </div>
              </div>

              <!-- LINKS -->
              <div class="card text-white mb-4" *ngIf="movie.links.length > 0">
                <div class="card-body">
                  <div class="titulo">Notas de Prensa</div>
                  <div class="temas">
                    <a [href]="link.link" target="_blank" class="badge badge-pill badge-dark mr-3 mb-3"
                      *ngFor="let link of movie.links">
                      <div class="d-flex align-items-center px-2">
                        {{link.name}} <i class="fas fa-external-link-alt pl-2"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- PANELES DERECHA -->
            <div class="col-12 col-xl-4 mb-4">

              <!-- COMPARTIR -->
              <div class="card text-white mb-4">
                <div class="card-body">
                  <div class="titulo">Compartir</div>

                  <div class="shared mb-2">
                    <a class="box" [href]="sharedUrls.facebook" title="Compartir en facebook" target="_blank">
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a class="box" [href]="sharedUrls.twitter" title="Compartir en twitter" target="_blank">
                      <i class="fab fa-twitter"></i>
                    </a>
                    <a class="box d-none d-md-inline" [href]="sharedUrls.whatsapp" title="Compartir en whatsapp"
                      target="_blank"> <i class="fab fa-whatsapp"></i>
                    </a>
                    <!-- <a class="box d-md-none" [href]="sharedUrls.whatsappMobile" title="Compartir en whatsapp"
                      target="_blank"> <i class="fab fa-whatsapp"></i>
                    </a> -->

                    <a class="box d-md-none" [href]="sharedUrls.whatsappMobile" data-action="share/whatsapp/share"
                      [data-param-description]="sharedText" [data-param-href]="sharedUrls.whatsappMobile"
                      [data-param-text]="sharedText" [data-param-url]="sharedUrl" target="_blank"
                      rel="noopener noreferrer" data-share-track-dtm="whatsapp" id="btn_share_whatsapp_768">
                      <i class="fab fa-whatsapp"></i>
                    </a>

                  </div>


                </div>
              </div>

              <!-- FICHA TECNICA -->
              <div class="card text-white mb-4" *ngIf="mostrarPanelProduccion">
                <div class="card-body">
                  <div class="titulo">Ficha Técnica</div>

                  <!-- Direccion -->
                  <div class="direccion mb-2" *ngIf="movie.directors.length > 0">
                    <strong class="text-secondary">Dirección: </strong>
                    <span *ngFor="let person of movie.directors; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.director + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{
                        person.lastName }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Elenco -->
                  <div class="direccion mb-2" *ngIf="movie.cast.length > 0">
                    <strong class="text-secondary mt-3">Elenco: </strong>
                    <span *ngFor="let person of movie.cast; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.actor + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{ person.lastName
                        }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Production -->
                  <div class="direccion mb-2" *ngIf="movie.production.length > 0">
                    <strong class="text-secondary">Producción: </strong>
                    <span *ngFor="let person of movie.production; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.production + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{
                        person.lastName }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Script -->
                  <div class="direccion mb-2" *ngIf="movie.script.length > 0">
                    <strong class="text-secondary">Guión: </strong>
                    <span *ngFor="let person of movie.script; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.script + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{
                        person.lastName }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Photography -->
                  <div class="direccion mb-2" *ngIf="movie.photography.length > 0">
                    <strong class="text-secondary">Dirección de Fotografía: </strong>
                    <span *ngFor="let person of movie.photography; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.photography + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{
                        person.lastName }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Sound -->
                  <div class="direccion mb-2" *ngIf="movie.sound.length > 0">
                    <strong class="text-secondary">Dirección de Sonido: </strong>
                    <span *ngFor="let person of movie.sound; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.sound + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{
                        person.lastName }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Music -->
                  <div class="direccion mb-2" *ngIf="movie.music.length > 0">
                    <strong class="text-secondary">Música: </strong>
                    <span *ngFor="let person of movie.music; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.music + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{
                        person.lastName }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Edition -->
                  <div class="direccion mb-2" *ngIf="movie.edition.length > 0">
                    <strong class="text-secondary">Edición: </strong>
                    <span *ngFor="let person of movie.edition; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.edition + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{
                        person.lastName }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Direccion de Arte -->
                  <div class="direccion mb-2" *ngIf="movie.artDirection.length > 0">
                    <strong class="text-secondary">Dirección de Arte: </strong>
                    <span *ngFor="let person of movie.artDirection; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.artDirection + '/' + person.id + '?label=' + person.name + ' ' + person.lastName">{{
                        person.name }} {{
                        person.lastName }}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <!-- Casa Productora -->
                  <div class="direccion mb-2" *ngIf="movie.productionCompany.length > 0">
                    <strong class="text-secondary">Casa Productora: </strong>
                    <span *ngFor="let company of movie.productionCompany; last as last">
                      <a
                        [href]="'/tag-search/' + tag_type.productionCompany + '/' + company.id + '?label=' + company.name">
                        {{company.name}}</a>
                      <span *ngIf="!last">, </span>
                    </span>
                  </div>

                </div>
              </div>

              <!-- PREMIOS -->
              <div class="card text-white mb-4" *ngIf="movie.awards.length > 0">
                <div class="card-body">
                  <div class="titulo">Premios</div>

                  <div class="premios">
                    <a href="#" class="badge badge-pill badge-dark mr-3 mb-3 Mw-100" *ngFor="let item of movie.awards">
                      <div class="d-flex align-items-center px-2">
                        <i class="fas fa-medal mr-2"></i>
                        <div [innerHTML]="item.description" class="text-wrap text-left">
                        </div>
                      </div>
                    </a>
                  </div>

                  <!-- <div class="badge award rounded-pill bg-light mr-xl-3" *ngFor="let item of movie.awards">
                    <div class="d-flex align-items-center px-2">
                      <i class="fas fa-medal"></i>
                      <div class="label">

                      </div>
                    </div>
                  </div> -->
                </div>
              </div>

              <!-- MAS INFORMACIÓN -->
              <div class="card text-white mb-4">
                <div class="card-body">
                  <div class="titulo">Más información</div>

                  <div class="genero mb-2" *ngIf="movie.genre">
                    <strong class="text-secondary">Género: </strong>
                    <a [href]="'/tag-search/' + tag_type.genero + '/' + movie.genre.id + '?label=' + movie.genre.name">{{
                      movie.genre.name }}</a>
                  </div>

                  <div class="pais mb-2" *ngIf="movie.countries.length > 0">

                    <strong class="text-secondary mt-3">País: </strong>
                    <span *ngFor="let pais of countries; last as last">
                      <a [href]="'/tag-search/' + tag_type.pais + '/' + pais.id + '?label=' + pais.name">
                        {{pais.name}}
                      </a>
                      <span *ngIf="!last">, </span>
                    </span>

                    <!-- Se acomodaban mal, lo cambie por el codigo de arriba pero dejo este por las dudas. -->
                    <!-- <strong class="text-secondary">País: </strong>
                    <div *ngFor="let pais of countries">
                      <a [href]="'/tag-search/' + tag_type.pais + '/' + pais.id">
                        {{pais.name}}
                      </a>
                    </div> -->
                  </div>

                  <div class="anio mb-2" *ngIf="movie.releaseYear">
                    <strong class="text-secondary">Año: </strong>
                    <a
                      [href]="'/tag-search/' + tag_type.anio + '/' + movie.releaseYear + '?label=' + movie.releaseYear">{{
                      movie.releaseYear }}</a>
                  </div>

                  <div class="duracion mb-2" *ngIf="movie.length">
                    <strong class="text-secondary">Duración: </strong>
                    <span>{{ movie.length }} min</span>
                  </div>

                  <div class="idioma mb-2" *ngIf="movie.language">
                    <strong class="text-secondary">Idioma: </strong>
                    <a
                      [href]="'/tag-search/' + tag_type.idioma + '/' + movie.language.id + '?label=' + movie.language.name">{{
                      movie.language.name }}</a>
                  </div>

                  <div class="duracion mb-2" *ngIf="movie.premierDateUY">
                    <strong class="text-secondary">Fecha de Estreno en Uruguay: </strong>
                    <span>{{ movie.premierDateUYformated }}</span>
                  </div>
                  <div class="duracion mb-2" *ngIf="movie.premierPlaceUY">
                    <strong class="text-secondary">Lugar de estreno: </strong>
                    <span>{{ movie.premierPlaceUY }}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <!-- TAB DE COMENTARIOS ACA -->
          <div class="row" *ngIf="tabSelected == 2">
            <div class="col-12">
              <app-comments-section [Movie]="movie"></app-comments-section>
            </div>
          </div>
          <!-- TAB DE FRAMES ACA -->
          <div class="row" *ngIf="tabSelected == 3">
            <div class="col-12 p-0 m-0">
              <app-movie-frames-gallery [Frames]="movie.frames"></app-movie-frames-gallery>
            </div>
          </div>

          <!-- <div class="card highlight-card">
            RECEIVED TOKEN: <span>{{ tokenID }}</span>
          </div>
          <button class="btn btn-outline-info" (click)="openIframe()">
            Pagar
          </button> -->
          <form id="payment_form"></form>
        </div>
      </div>
    </div>

    <br />
  </div>
</div>